import { useState } from "react";

const KEYS = ["C", "(", ")", "÷", "7", "8", "9", "×", "4", "5", "6", "-", "1", "2", "3", "+", "%", "0", ".", "="];

const evaluate = (expr) => {
  const s = expr.replace(/×/g, "*").replace(/÷/g, "/").replace(/%/g, "/100");
  if (!/^[0-9+\-*/(). ]+$/.test(s)) throw new Error("bad");
  // eslint-disable-next-line no-new-func
  const v = Function(`"use strict";return (${s})`)();
  if (!isFinite(v)) throw new Error("bad");
  return Math.round(v * 1e8) / 1e8;
};

export function Calculator() {
  const [expr, setExpr] = useState("");
  const [result, setResult] = useState("");
  const [history, setHistory] = useState([]);

  const press = (k) => {
    if (k === "C") { setExpr(""); setResult(""); return; }
    if (k === "=") {
      try {
        const v = evaluate(expr);
        setResult(String(v));
        setHistory((h) => [{ expr, v }, ...h].slice(0, 6));
      } catch { setResult("خطأ"); }
      return;
    }
    setExpr((e) => e + k);
  };

  return (
    <div className="space-y-4">
      <div className="panel p-4 text-left" dir="ltr">
        <input data-testid="calculator-display" value={expr} onChange={(e) => setExpr(e.target.value)} placeholder="0"
          className="w-full bg-transparent font-mono text-lg text-slate-200 outline-none" />
        <p data-testid="calculator-result" className="font-mono text-3xl font-semibold text-cyan-300 min-h-[40px]">{result}</p>
      </div>
      <div className="grid grid-cols-4 gap-2" dir="ltr">
        {KEYS.map((k) => (
          <button key={k} data-testid={`calculator-key-${k === "=" ? "equals" : k === "C" ? "clear" : k === "×" ? "mul" : k === "÷" ? "div" : k === "+" ? "plus" : k === "-" ? "minus" : k === "." ? "dot" : k === "%" ? "percent" : k === "(" ? "open" : k === ")" ? "close" : k}`}
            onClick={() => press(k)}
            className={`h-12 rounded-xl font-mono text-base transition-all active:scale-95 ${k === "=" ? "bg-cyan-400 text-slate-950 hover:bg-cyan-300" : k === "C" ? "bg-red-500/15 text-red-300 hover:bg-red-500/25" : /[0-9.]/.test(k) ? "bg-white/[0.06] text-slate-100 hover:bg-white/10" : "bg-white/[0.03] text-cyan-200 hover:bg-white/[0.08]"}`}>
            {k}
          </button>
        ))}
      </div>
      {history.length > 0 && (
        <div className="space-y-1" data-testid="calculator-history">
          <p className="text-[11px] font-mono uppercase tracking-wider text-slate-500">السجل</p>
          {history.map((h, i) => (
            <div key={i} className="flex justify-between font-mono text-xs text-slate-400" dir="ltr">
              <span>{h.expr}</span><span className="text-slate-200">= {h.v}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
